import React, {useMemo, useRef, useState} from 'react';
import Form, {FormInputComponent} from "../../components/form/Form";
import {useOpportunity} from "../../providers/OpportunityProvider";
import {useAuth} from "../../providers/AuthProvider";
import {Alert, Card, Checkbox, Collapse, Divider, InputNumber, Statistic} from "antd";
import Marquee from "react-fast-marquee";
import UserDiscipline from "../../models/UserDiscipline";

const EditProposedPayoutByRole = ({discipline, index, isDisabled, ...props}) => {

    const [isCollapseActive, setIsCollapseActive] = useState(false);

    const estimatedPayout = useMemo(() => {
        const hours = parseInt(discipline.total_hours);
        const rate = parseFloat(discipline.hourly_rate);

        if (TB.isNaN(hours) || TB.isNaN(rate)) {
            return 0;
        }

        return Math.ceil(hours * rate);
    }, [discipline?.total_hours, discipline.hourly_rate])

    const proposedPayout = useMemo(() => {
        const hours = parseInt(discipline.has_accepted_proposed_payout ? discipline.total_hours : discipline.proposed_total_periods || discipline.total_hours);
        const rate = parseFloat(discipline.has_accepted_proposed_payout ? discipline.hourly_rate : discipline.proposed_hourly_rate || discipline.hourly_rate);

        if (TB.isNaN(hours) || TB.isNaN(rate)) {
            return 0;
        }

        return Math.ceil(hours * rate);
    }, [
        discipline?.total_hours,
        discipline?.hourly_rate,
        discipline?.proposed_total_periods,
        discipline?.proposed_hourly_rate,
        discipline.has_accepted_proposed_payout
    ])
    const storedDiscipline = UserDiscipline.storedDiscipline(discipline.id, false);


    return (
        <div className="flex flex-col gap-3 mt-3 p-0 md:px-6 md:py-4">

            <div className="lg:flex flex-col items-start my-2">
                <h3 className="proposal-tab-header whitespace-nowrap mr-2 mb-1 mt-0">
                    Team Role:&nbsp;<span className="text-primary">{discipline.name}</span>
                </h3>
                {storedDiscipline && (
                    <p className="proposal-tab-subheader mb-0 mt-0">
                        {storedDiscipline.description}
                    </p>
                )}
            </div>

            <div className="px-4 py-3 border border-[#913ef0] mt-3">
                <div className="flex flex-row-reverse justify-between items-start">

                    <div className="flex flex-row flex-nowrap items-center justify-center gap-2.5 min-w-[20%]">
                        {/*{parseInt(proposedPayout) !== parseInt(estimatedPayout) && (*/}
                        {/*    <Statistic title="Estimated Payout" value={TB.formatNumber(estimatedPayout, 2)}*/}
                        {/*               formatter={value => (*/}
                        {/*                   <span className="line-through text-danger">*/}
                        {/*                       {TB.formatCurrency(value, false)}*/}
                        {/*                   </span>*/}
                        {/*               )}/>*/}
                        {/*)}*/}

                        <Card bordered={false} className="bg-gray-100" size="small">
                            <Statistic
                                title={
                                    parseInt(proposedPayout) === parseInt(discipline.payout_amount) ? 'Estimated Payout' :
                                        <span className="opacity-60 text-danger">Proposed Payout</span>}
                                value={TB.formatNumber(proposedPayout, 2)}
                                formatter={value => TB.formatCurrency(value, false)}/>
                        </Card>
                    </div>


                    <div className="flex-grow">


                        <div className="flex flex-col gap-3 mt-3" key={`editing-dis-${discipline.id}`}>

                            {discipline.payout_amount !== discipline.original_payout_amount && (
                                <div className="w-full max-w-[700px] mb-5">
                                    <Alert
                                        type="warning"
                                        showIcon
                                        message={
                                            <Marquee pauseOnHover speed={80} delay={1.5} gradient={false}>
                                                <b>Note:</b>&nbsp;Your proposed hours and rate are being reviewed by the
                                                client lead. We may reach out
                                                via email for more
                                                information.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </Marquee>
                                        }
                                    />
                                </div>
                            )}
                            <FormInputComponent
                                type="antd-input"
                                label={false}
                                className="flex flex-row items-center self-start"
                                fieldName={`disciplines[${index}].has_accepted_proposed_payout`}
                                disabled={isDisabled}
                                value={discipline.has_accepted_proposed_payout}
                            >
                                <Checkbox checked={discipline.has_accepted_proposed_payout}>
                                    By checking this box, I accept an hourly rate
                                    of <b>${TB.formatNumber(discipline.hourly_rate, 0)}/hr</b> for a total
                                    of <b>{discipline.total_hours} hours.</b>
                                </Checkbox>
                            </FormInputComponent>

                            <div
                                className="sm:flex md:block min-[880px]:flex flex-row items-start justify-start gap-4">

                                <label className="col-form-label">
                                    Proposed Hourly Rate:
                                </label>
                                <FormInputComponent
                                    type="antd-input"
                                    label={false}
                                    className="sm:w-1/2 md:w-full min-[880px]:w-1/2 lg:w-1/3"
                                    fieldName={`disciplines[${index}].proposed_hourly_rate`}
                                    disabled={discipline.has_accepted_proposed_payout || isDisabled}
                                    value={discipline.proposed_hourly_rate}
                                    required={!discipline.has_accepted_proposed_payout}
                                    min={1}
                                >

                                    <InputNumber
                                        precision={0}
                                        controls={false}
                                        addonBefore="$"
                                        addonAfter=" per hour "
                                        step={1}
                                        defaultValue={Number.parseInt(discipline.hourly_rate).toFixed(0)}
                                    />

                                </FormInputComponent>
                            </div>
                            <div
                                className="sm:flex md:block min-[880px]:flex flex-row items-start justify-start gap-4">
                                <label className="col-form-label">
                                    Proposed Total Hours:
                                </label>
                                <FormInputComponent
                                    type="antd-input"
                                    label={false}
                                    className="sm:w-1/2 md:w-full min-[880px]:w-1/2 lg:w-1/3"
                                    fieldName={`disciplines[${index}].proposed_total_periods`}
                                    disabled={discipline.has_accepted_proposed_payout || isDisabled}
                                    value={discipline.proposed_total_periods}
                                    required={!discipline.has_accepted_proposed_payout}
                                    min={1}
                                    validation={{
                                        rules: {
                                            isInt: true,
                                        }
                                    }}
                                >

                                    <InputNumber
                                        min={1}
                                        controls={false}
                                        addonAfter={<span className="text-[13px]">hours</span>}
                                        defaultValue={discipline.total_hours}
                                    />

                                </FormInputComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Collapse className="mt-5" ghost activeKey={isCollapseActive}
                      onChange={key => setIsCollapseActive(TB.first(key || []))}>
                <Collapse.Panel key="deliverables" showArrow={false} header={(
                    <div className="flex flex-col items-center">
                        <p className="text-gray-400 flex flex-row items-center gap-2">
                            <i className={TB.mapClass("transition-all fas text-xs", {
                                "fa-angle-double-down": true,//!isCollapseActive,
                                // "fa-angle-double-up": isCollapseActive,
                                "rotate-180": isCollapseActive,
                                "rotate-0": !isCollapseActive,
                            })}/>
                            <span>
                                {isCollapseActive ? 'Hide' : 'View'} estimated hours by deliverable
                            </span>
                            <i className={TB.mapClass("transition-all fas text-xs", {
                                "fa-angle-double-down": true,//!isCollapseActive,
                                // "fa-angle-double-up": isCollapseActive,
                                "rotate-180": isCollapseActive,
                                "rotate-0": !isCollapseActive,
                            })}/>
                        </p>
                    </div>
                )}>
                    <div className="flex flex-col items-stretch divide-y divide-gray-200">
                        {TB.map(discipline.deliverables, deliverable => {

                            let activeDisciplines = [discipline];//TB.filter(opportunity.disciplines, dis => TB.find(dis.deliverables, ['id', deliverable.id]));

                            if (!activeDisciplines) {
                                return null;
                            }
                            return (
                                <div className="flex flex-row items-center justify-between py-1.5"
                                     key={`del-${deliverable.id}`}>
                                    <p className="font-medium flex-1 text-sm">
                                        {deliverable.name}
                                    </p>
                                    <p className="text-info text-xs flex-1 text-center">
                                        {TB.map(activeDisciplines, 'name').join(', ')}
                                    </p>

                                    <p className="flex-1 text-xs text-right">
                                        {deliverable.total_hours} hours
                                    </p>
                                </div>
                            )
                        })}

                        <div className="flex flex-row items-center justify-between py-2">
                            <p className="font-semibold flex-1 text-sm">

                            </p>
                            <p className="font-semibold flex-1 text-xs text-right">
                                Total: {TB.sumBy(discipline.deliverables, 'total_hours')} hours
                            </p>
                        </div>
                    </div>
                </Collapse.Panel>
            </Collapse>
            <Divider/>
        </div>
    )
}
const TeamMemberPayoutEditTab = ({
                                     onUpdate = async () => true,
                                     showSteps,
                                     getStepActions = false
                                 }) => {

    const {
        opportunity,
        isDisabled,
        changeProps,
        onRequest
    } = useOpportunity();

    const {auth} = useAuth();
    const editable = opportunity.canEditProposal();

    const mappedDisciplines = useMemo(() => {
        return TB.map(opportunity.disciplines, dis => {
            const original_rate = parseFloat(dis.proposed_hourly_rate || dis.hourly_rate);
            const original_total_periods = parseInt(dis.proposed_total_periods || dis.total_hours);
            const original_payout_amount = original_rate * original_total_periods;
            let has_accepted_proposed_payout = false;
            if (!dis.proposed_total_periods && !dis.proposed_hourly_rate) {
                has_accepted_proposed_payout = true
            }
            if (dis.proposed_total_periods === dis.total_hours && Number.parseFloat(dis.proposed_hourly_rate) === Number.parseFloat(dis.hourly_rate)) {
                has_accepted_proposed_payout = true
            }
            return {
                ...dis,
                original_rate,
                original_total_periods,
                original_payout_amount,
                has_accepted_proposed_payout
            }
        });
    }, [opportunity, isDisabled]);

    const mapping = (model = {}) => {

        return model;
    }

    const formRef = useRef(null);

    const [formModel, setFormModel] = useState(() => ({disciplines: [...mappedDisciplines]}));

    let changedDisciplines = useMemo(() => {
        return TB.filter(formModel.disciplines, discipline => {
            return parseFloat(discipline.original_rate) !== parseFloat(discipline.proposed_hourly_rate || discipline.hourly_rate) ||
                parseInt(discipline.original_total_periods) !== parseInt(discipline.proposed_total_periods || discipline.total_hours)
        });
    }, [
        ...TB.map(formModel?.disciplines, 'proposed_total_periods'),
        ...TB.map(formModel?.disciplines, 'proposed_hourly_rate')
    ]);
    // console.log('TeamMemberPayoutEditTab', hadDifferentPayout)
    const hasFormModelChanged = changedDisciplines.length > 0;

    console.log('Success: opportunity', opportunity)

    const resetForm = async () => {

        // await setFormModel({disciplines: [...mappedDisciplines]});
        return formRef.current?.forceReset({disciplines: [...mappedDisciplines]})
    }

    const submitForm = async () => {
        // let invalid = formRef.current.forceValidate(formModel);
        // if (invalid) {
        //     console.log('invalid', invalid)
        //     return;
        // }
        let updateProps = TB.pick({...formModel}, ['disciplines', 'message_to_consultant']);

        updateProps.disciplines = TB.map(
            updateProps.disciplines,
            dis => {
                return {
                    id: dis.id,
                    proposed_total_periods: dis.has_accepted_proposed_payout ? null : dis.proposed_total_periods,
                    proposed_hourly_rate: dis.has_accepted_proposed_payout ? null : dis.proposed_hourly_rate
                }
            }
        );
        let success = await onUpdate(updateProps)

        if (success) {
            await resetForm();
        }
    }
    return (
        <React.Fragment>
            {getStepActions ? getStepActions(
                'Please review your team role and confirm your bill rate and estimated payout to work on the project',
                submitForm
            ) : (
                <div className="proposal-tab-header block sm:flex flex-row items-start">
                    <span className="mr-3">
                        Please review your team role and confirm your bill rate and estimated payout to work on the project
                    </span>
                </div>
            )}



            <div className="opp-talent-proposal-form opp-member-proposal-form">
                <Form
                    ref={formRef}
                    background={"transparent"}
                    mapping={mapping}
                    minimal={true}
                    onSubmit={submitForm}
                    submitButton={false}
                    isDisabled={isDisabled}
                    model={formModel}
                    fields={[]}
                    className={
                        TB.mapClass({
                            'no-edit': !editable
                        })
                    }
                    onChange={async (model) => {
                        let updatedModel = {...formModel};
                        let formUpdates = {}

                        TB.map(formModel.disciplines, (discipline, disciplineIndex) => {
                            let isChecked = TB.get(model, `disciplines[${disciplineIndex}].has_accepted_proposed_payout`);
                            if (TB.isDefined(isChecked) && discipline.has_accepted_proposed_payout !== isChecked) {
                                formUpdates = {
                                    ...formUpdates,
                                    [`disciplines[${disciplineIndex}].proposed_hourly_rate`]: parseFloat(discipline.hourly_rate),
                                    [`disciplines[${disciplineIndex}].proposed_total_periods`]: parseInt(discipline.total_hours)
                                }
                            }
                        })

                        for (let [key, value] of Object.entries(model)) {
                            updatedModel = TB.set(updatedModel, key, value);
                        }

                        await setFormModel(updatedModel);
                        if (Object.keys(formUpdates).length && formRef.current) {
                            return formRef.current.updateInputsWithValue(formUpdates, false);
                        }
                    }}>
                    {mappedDisciplines?.length > 0 &&
                        TB.map(mappedDisciplines, (discipline, disciplineIndex) => (
                            <EditProposedPayoutByRole
                                key={discipline.id}
                                isDisabled={isDisabled}
                                index={disciplineIndex}
                                discipline={discipline}
                            />
                        ))}

                    {editable && !showSteps && (
                        <div className="mt-3 flex flex-row justify-end">
                            <button type="submit" className="btn btn-primary mr-3"
                                    disabled={isDisabled || !hasFormModelChanged}>
                                Save
                            </button>
                            <button className="btn btn-outline-dark"
                                    type="button" onClick={resetForm}
                                    disabled={isDisabled || !hasFormModelChanged}>
                                Cancel
                            </button>
                        </div>
                    )}

                </Form></div>
        </React.Fragment>
    );
};

export default TeamMemberPayoutEditTab;